import "../scss/styles.scss";
// Default js file. You can add the plugins in the /vendors folder
(function () {
	"use strict";

	var APP = APP || {};

	APP.CommonClasses = {
		active: "is-active",
		open: "is-open",
		push: "is-pushed",
	};

	APP.SearchModule = {
		el: {
			headerSearch_menu: $("#header--search"),
			headerSearch_btn: $(".nav--secondary"),
			headerSearch_form: $("#header--form"),
			form_input: $(".searchform--input"),
		},
		init: function () {
			this.binds();
		},
		binds: function () {
			this.el.headerSearch_menu.on(
				"click",
				this.ToggleHeaderSearch.bind(this),
			);
		},
		ToggleHeaderSearch: function () {
			this.el.headerSearch_menu.toggleClass(APP.CommonClasses.active);
			this.el.headerSearch_form.toggleClass(APP.CommonClasses.open);
			this.el.headerSearch_form.slideToggle();
			this.el.form_input.focus();
			$("#header--search").addClass("is-active");
			// Add timer to auto-close the search if unused
			if (this.el.headerSearch_form.hasClass(APP.CommonClasses.open)) {
				setTimeout(this.InactiveSearch.bind(this), 2000);
			}
		},
		InactiveSearch: function () {
			if (
				this.el.headerSearch_form.find(this.el.form_input).val() == ""
			) {
				this.ToggleHeaderSearch();
				$("#header--search").removeClass("is-active");
			}
		},
	};

	//MATCH HEIGHT FUNCTION FOR PICNIC CHIC 2017 ON INSCRIPTION PAGE FOR INSTANT PRIZE
	$(".prize-listing-container .description").matchHeight();
	$(".prize-listing-container .fixed-height").matchHeight();
	$(".prize-listing .prize-desc").matchHeight();

	// Products title
	$(".product-item .product-item__title").matchHeight();

	APP.init = function () {
		// List all module
		APP.SearchModule.init();
	};

	APP.init();

	window.$kol_jquery = window.jQuery;

	// Banner - Scroll to content
	$("a.scroll").on("click", function (e) {
		e.preventDefault();
		$("html, body").animate(
			{
				scrollTop: $(this).parent().next().offset().top - 127,
			},
			600,
		);
	});

	//Accordion
	if ($(".accordeon").length) {
		$(".accordeon")
			.find(".title")
			.click(function () {
				var $accordion = $(this).parent();
				if ($accordion.hasClass("open")) {
					$accordion.removeClass("open");
					$accordion.find(".ac-content").slideUp(400);
				} else {
					$accordion.addClass("open");
					$accordion.find(".ac-content").slideDown(400);
				}
			});
	}

	//mobile-nav
	$(".mobile-nav").on("click", function () {
		$(this).toggleClass("is-active");
		$("#mobile-navigation").toggleClass("is-active");
	});

	// form  animations
	animateFormInputs();

	$(".single-line input").each(function () {
		if ($(this).val()) {
			$(this).parent().parent().find("label").addClass("is-active");
		}
	});

	$(".ginput_container_address").each(function () {
		if ($(".ginput_container_address input").val()) {
			$(".ginput_container_address input")
				.parent()
				.parent()
				.find("label")
				.addClass("is-active");
		}
	});

	//////////////////
	// SOCIAL SHARE //
	//////////////////

	if ($("#share-action").length || $(".contest-confirmation").length) {
		$(".share-facebook").on("click", function (e) {
			e.preventDefault();
			var local = $(this).attr("href");
			window.open(
				"http://www.facebook.com/sharer.php?u=" + local,
				"sharer",
				"toolbar=0,status=0,width=550,height=620,top=" +
					($(window).height() / 2 - 310) +
					",left=" +
					($(window).width() / 2 - 275) +
					",resizable=yes",
			);
		});

		$(".share-twitter").on("click", function (e) {
			e.preventDefault();
			var local = $(this).attr("href");
			window.open(
				"https://twitter.com/intent/tweet?url=" + local,
				"twitterwindow",
				"height=310, width=550, top=" +
					($(window).height() / 2 - 155) +
					", left=" +
					($(window).width() / 2 - 275) +
					", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0",
			);
		});

		$(".share-pinterest").on("click", function (e) {
			e.preventDefault();
			var local = $(this).attr("href"),
				desc = $(this).data("desc"),
				imgurl = $(this).data("img");
			window.open(
				"//www.pinterest.com/pin/create/button/?url=" +
					local +
					"&media=" +
					imgurl +
					"&description=" +
					desc,
				"sharer",
				"toolbar=0,status=0,width=750,height=610, top=" +
					($(window).height() / 2 - 305) +
					", left=" +
					($(window).width() / 2 - 375) +
					",resizable=yes",
			);
		});

		$(".icon-print").on("click", function (e) {
			e.preventDefault();
			window.print();
		});
	}

	if ($("#gform_3").length) {
		$("body").on("click", "#gform_3", function (e) {
			//Cloning gravity form
			$("#kickoff-name").val($("#input_3_1").val());
			$("#kickoff-last-name").val($("#input_3_2").val());
			$("#kickoff-email").val($("#input_3_3").val());
			$("#kickoff-postal-code").val($("#input_3_5_5").val());
		});
		$(document).bind("gform_post_render", function () {
			$(".single-line input").each(function () {
				if ($(this).val()) {
					$(this)
						.parent()
						.parent()
						.find("label")
						.addClass("is-active");
				}
			});
			$(".ginput_container_address").each(function () {
				if ($(".ginput_container_address input").val()) {
					$(".ginput_container_address input")
						.parent()
						.parent()
						.find("label")
						.addClass("is-active");
				}
			});
			animateFormInputs();
		});
		$(document).bind("gform_confirmation_loaded", function (event, formId) {
			$("#fake-form").submit();
		});
	}
	// $( document ).ready(function() {
	//   if($(".single-line input").val()){
	// 		$(".single-line input").parent().parent().find("label").addClass("is-active");
	// 	}
	//  if($(".ginput_container_address input").val()){
	// 		$(".ginput_container_address input").parent().find("label").addClass("is-active");
	// 	}
	// });

	window.pState = false;
	window.addEventListener("popstate", function (e) {
		console.log("addEventListener popstate");
		var state = e.state;
		window.pState = true;
		$(".recipes-container").html("");
		if (state !== null && state.id == "filterrecipe") {
			console.log("state change FLAVOR");
			$(".listing-recipes").addClass("filtered");
			$(".recipes-listing--large").hide();
			history.scrollRestoration = "manual"; //To maintain the scroll position
			//filterRecipes(state.recipe_slug, true);
			$(".category-select .custom-drop").addClass("ready");
			$(".type-select .custom-drop").removeClass("ready");
			window.selectBox.selectOption(state.recipe_slug);
			window.selectBoxts.selectOption("0");
		} else if (state !== null && state.id == "filtertype") {
			console.log("state change TYPE");
			history.scrollRestoration = "manual"; //To maintain the scroll position
			$(".listing-recipes").addClass("filtered");
			$(".recipes-listing--large").show();
			//filterRecipes('0', true);
			$(".type-select .custom-drop").addClass("ready");
			$(".category-select .custom-drop").removeClass("ready");
			window.selectBox.selectOption("0");
			window.selectBoxts.selectOption(state.recipe_slug);
		} else if (state !== null && state.id == "pagerecipe") {
			history.scrollRestoration = "manual"; //To maintain the scroll position
			$(".listing-recipes").removeClass("filtered");
			$(".recipes-listing--large").show();
			//filterRecipes('0', true);
			window.selectBox.selectOption("0");
			window.selectBoxts.selectOption("0");
		} else {
			$(".listing-recipes").removeClass("filtered");
			$(".recipes-listing--large").show();
			//filterRecipes('0', true);
			window.selectBox.selectOption("0");
			window.selectBoxts.selectOption("0");
		}
	});
})();

// form single line elements
function animateFormInputs() {
	$(".single-line input").focusout(function () {
		if (!$(this).val()) {
			$(this).parent().parent().find("label").removeClass("is-active");
		}
	});
	$(".ginput_container_address input").focusout(function () {
		if (!$(this).val()) {
			$(this).parent().find("label").removeClass("is-active");
		}
	});
	$(".ginput_container_address input").on(
		"change paste keyup focus",
		function () {
			$(this).parent().find("label").addClass("is-active");
		},
	);
	$(".single-line input").on("change paste keyup focus", function () {
		$(this).parent().parent().find("label").addClass("is-active");
	});
}

//FUNCTION ON SUBMIT PIN CODE AN
$("#submit-code").on("click", function (e) {
	e.preventDefault();
	var code = $("#inputCode").val();
	if (code == "") {
		var message = $("#messages-hidden").data("empty");
		$("#code-response").html(message);
	} else {
		$(this).hide();
		$("#spinner").show();

		jQuery.post(
			ajaxurl,
			{
				action: "code_response",
				code: code,
			},
			function (response) {
				if (response.state === "valid") {
					var result_url = $("#url-hidden").data("url-result");
					window.location.href = result_url;
				} else {
					// $('#code-response').html(response.message);
					if (response.message == "not valid") {
						var message = $("#messages-hidden").data("not-valid");
						$("#code-response").html(message);
					} else if (response.message == "already used") {
						var message =
							$("#messages-hidden").data("already-used");
						$("#code-response").html(message);
					}

					$("#submit-code").show();
					$("#spinner").hide();
				}
			},
		);
	}
});

//FUNCTION FOR TIMER
function getTimeRemaining(endtime) {
	var t = endtime - Date.now() / 1000;
	var seconds = Math.floor(t % 60);
	var minutes = Math.floor((t / 60) % 60);
	return {
		total: t,
		// 'days': days,
		// 'hours': hours,
		minutes: minutes,
		seconds: seconds,
	};
}

function initializeClock(id, endtime) {
	var clock = document.getElementById(id);
	var minutesSpan = clock.querySelector(".minutes");
	var secondsSpan = clock.querySelector(".seconds");

	function updateClock() {
		var t = getTimeRemaining(endtime);
		minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
		secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);
		if (t.total <= 0) {
			clearInterval(timeinterval);
			$("#countdown").html("");
			$("#postal-form").hide();
			$(".form-note").hide();
			$("#time-over").show();
		}
	}

	updateClock();
	var timeinterval = setInterval(updateClock, 1000);
}
if ($("#countdown").length) {
	$("#time-over").hide();
	var deadline =
		Math.floor(Date.now() / 1000) + $("#countdown").data("time-remaining");
	initializeClock("countdown", deadline);
}

$("#city-1").on("click", function (e) {
	e.preventDefault();
	clearChecked();
	$("#input_11_9").val("toronto");
	$(this).addClass("checked");
});

$("#city-2").on("click", function (e) {
	e.preventDefault();
	clearChecked();
	$("#input_11_9").val("montreal");
	$(this).addClass("checked");
});

$("#city-3").on("click", function (e) {
	e.preventDefault();
	clearChecked();
	$("#input_11_9").val("vancouver");
	$(this).addClass("checked");
});
function clearChecked() {
	$("#city-1").removeClass("checked");
	$("#city-2").removeClass("checked");
	$("#city-3").removeClass("checked");
}

if ($("#pre-contest").length > 0) {
	if ($(".gform_confirmation_message").length > 0) {
		$(".price-container").hide();
		$(".form-note").hide();
	}
}

// Fancybox lightbox
if ($("a.popup-link").length > 0) {
	$("a.popup-link").fancybox({
		type: "iframe",
		iframe: {
			css: {
				width: "80%",
				height: "90%",
			},
		},
	});
}

// Gestion de soumission du form si le prix concours 2018 est choisi
$("#gform_18").submit(function (e) {
	if ($(".prize-count").hasClass("selected")) {
		$(".check-prize").removeClass("error");
	} else {
		window["gf_submitting_18"] = false;
		$(".check-prize").addClass("error");
		$("html, body").animate(
			{
				scrollTop: $(".plus-sign").offset().top - 150,
			},
			1000,
		);
		return false;
	}
});

// Choix de prix concours 2018
if ($(".picnic-prizes").length) {
	$("label.prize-radio").on("click", function () {
		$(".check-prize").removeClass("error");
		$(".prize-count").addClass("selected");
		$prizeChosen = $(this).data("prize");
		$(".gform_fields input:hidden").val($prizeChosen);
	});
}

// Scroll down au formulaire
if ($(".claim-prize").length) {
	$(".claim-prize").on("click", function () {
		$(".prize-count").addClass("selected");
		$("html, body").animate(
			{
				scrollTop: $("#start-here").offset().top,
			},
			1000,
		);
	});
}

// Styler le dropdown des types de recettes
if ($(".category-select").length) {
	window.selectBox = $(".category-select .custom-drop")
		.selectBoxIt()
		.data("selectBox-selectBoxIt");
	$(".category-select .custom-drop")
		.selectBoxIt({
			autoWidth: true,
			showEffect: "fadeIn",
			showEffectSpeed: 400,
			hideEffect: "fadeOut",
			hideEffectSpeed: 400,
			hideCurrent: false,
		})
		.change(function () {
			var selection = $(this).val();
			// $('.type-select .custom-drop').removeClass('ready');
			// $('.category-select .custom-drop').addClass('ready');
			if ($(".category-select .custom-drop").hasClass("recipe-items")) {
				console.log("inside");
				if ($("html").attr("lang") == "fr-FR") {
					$(".type-select .selectboxit-text").html("Tous les types");
				} else {
					$(".type-select .selectboxit-text").html("All types");
				}
				filterRecipes(selection, window.pState);
				window.pState = false;
			} else if (
				$(".category-select .custom-drop").hasClass("product-items")
			) {
				filterProducts(selection);
			}
		});
}
// Styler le dropdown des types de recettes
if ($(".type-select").length) {
	window.selectBoxts = $(".type-select .custom-drop")
		.selectBoxIt()
		.data("selectBox-selectBoxIt");
	$(".type-select .custom-drop")
		.selectBoxIt({
			autoWidth: true,
			showEffect: "fadeIn",
			showEffectSpeed: 400,
			hideEffect: "fadeOut",
			hideEffectSpeed: 400,
			hideCurrent: false,
		})
		.change(function () {
			var selection = $(this).val();
			// $('.type-select .custom-drop').addClass('ready');
			// $('.category-select .custom-drop').removeClass('ready');
			if ($(".type-select .custom-drop").hasClass("type-items")) {
				if ($("html").attr("lang") == "fr-FR") {
					$(".category-select .selectboxit-text").html(
						"Toutes les saveurs",
					);
				} else {
					$(".category-select .selectboxit-text").html(
						"All the flavours",
					);
				}
				filterTypes(selection, window.pState);
				window.pState = false;
			} else if (
				$(".type-select .custom-drop").hasClass("product-items")
			) {
				filterProducts(selection);
			}
		});
}

// Recipes - Update results
function filterRecipes(selection, pop) {
	var filterVar = $("html").attr("lang") == "en-US" ? "flavour/" : "saveur/";
	$("#category-select .selectboxit-container").addClass("loading");
	$.ajax({
		type: "post",
		url: ajaxurl,
		dataType: "json",
		data: {
			action: "filter_recipes",
			value: selection,
		},
		success: function (response) {
			$(".recipes-container").html("");
			$(".custom-drop").val(selection);
			$("#category-select .selectboxit-container").removeClass("loading");

			if (!pop) {
				if (selection != "0") {
					$(".recipes-listing--large").hide();
					$(".listing-recipes").addClass("filtered");
					window.history.pushState(
						{
							id: "filterrecipe",
							recipe_slug: selection,
						},
						"Show recipe : " + selection,
						window.recipesurl + filterVar + selection,
					);
				} else {
					$(".recipes-listing--large").show();
					$(".listing-recipes").removeClass("filtered");
					window.history.pushState(
						{
							id: "pagerecipe",
							recipe_slug: selection,
						},
						"Show recipes page",
						window.recipesurl,
					);
				}
			}

			$(".recipes-container").html(response);
		},
	});
}

// Recipes type - Update results
function filterTypes(selection, pop) {
	var filterVar =
		$("html").attr("lang") == "en-US" ? "meal-type/" : "type-repas/";
	$("#type-select .selectboxit-container").addClass("loading");
	$.ajax({
		type: "post",
		url: ajaxurl,
		dataType: "json",
		data: {
			action: "filter_types",
			value: selection,
		},
		success: function (response) {
			$(".recipes-container").html("");
			$(".custom-drop-type").val(selection);
			$("#type-select .selectboxit-container").removeClass("loading");

			if (!pop) {
				if (selection != "0") {
					$(".recipes-listing--large").hide();
					$(".listing-recipes").addClass("filtered");
					window.history.pushState(
						{
							id: "filtertype",
							recipe_slug: selection,
						},
						"Show recipe : " + selection,
						window.recipesurl + filterVar + selection,
					);
				} else {
					$(".recipes-listing--large").show();
					$(".listing-recipes").removeClass("filtered");
					window.history.pushState(
						{
							id: "pagerecipe",
							recipe_slug: selection,
						},
						"Show recipes page",
						window.recipesurl,
					);
				}
			}

			$(".recipes-container").html(response);
		},
	});
}

// Products - Update results
function filterProducts(selection) {
	$.ajax({
		type: "post",
		url: ajaxurl,
		dataType: "json",
		data: {
			action: "filter_products",
			value: selection,
		},
		success: function (response) {
			$(".products-container").html("");
			$(".products-container").html(response);
		},
	});
}

$(".btn-trigger-form").click(function (e) {
	e.preventDefault();
	$(".summer-form-container").addClass("opened");
});

//Automatic start download after submition of the form
$(document).bind("gform_confirmation_loaded", function (event, formId) {
	if (formId === 20 || formId === 21) {
		var download_url = $("#generated-download-link").attr("rel");
		if (download_url) {
			var delay = 500;
			setTimeout(function () {
				window.open("/download?filename=" + download_url, "_blank");
			}, delay);
		}
	}
});
